import { Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { CreateExternalApplicationTokenModel } from '../models/CreateExternalApplicationTokenModel';
import { Observable } from 'rxjs';
import { AuthenticationTokenSummary } from '../models/AuthenticationTokenSummary';
import { RoleInfo } from '../models/RoleInfo';
import { CreateExternalApplicationResponse } from '../models/CreateExternalApplicationResponse';

@Injectable()
export class UserTokenService {
  constructor(private http: HttpService) {}

  public createNewToken(model: CreateExternalApplicationTokenModel): Observable<CreateExternalApplicationResponse> {
    return this.http.post('appToken', model);
  }

  public checkAppToken(token: string): Observable<AuthenticationTokenSummary> {
     return this.http.post('appToken/check', { token }).map((res: AuthenticationTokenSummary) => {
       res.expireAt = new Date(res.expireAt as any as string);
       return res;
     });
  }

  public resetSecret() {
    return this.http.post('appToken/reset-secret', null);
  }

  public getAllRoles(): Observable<RoleInfo[]> {
    return this.http.get('appToken/roles');
  }
}
